import { STREAM_PRIVACY_MASK } from '../config/streamPrivacy';
import { drawStreamPrivacyMask } from './drawStreamPrivacyMask';

/**
 * Wariant A: wypala maskę w piksele wideo w przeglądarce.
 *
 * Rysuje co klatkę kadr źródłowego <video> na canvas, nakłada rozmytą strefę
 * (geometria względem klatki, z configu — bez DOM), a wynik udostępnia jako
 * MediaStream (tylko obraz). Audio zostaje na źródłowym elemencie — dzięki temu
 * nie trzeba muxować dźwięku, a strona dalej go odtwarza (także w PiP).
 *
 * Zwraca kontroler { stream, stop } albo null, gdy się nie uda (→ fallback B).
 */
export function bakePrivacyStream(sourceVideo, { fps = 30 } = {}) {
    if (!STREAM_PRIVACY_MASK.enabled || !sourceVideo) return null;

    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    if (!ctx || typeof canvas.captureStream !== 'function') return null;

    let stream;
    try {
        stream = canvas.captureStream(fps);
    } catch {
        return null;
    }

    let running = true;
    let rafId = 0;

    const draw = () => {
        if (!running) return;
        rafId = requestAnimationFrame(draw);

        const vw = sourceVideo.videoWidth;
        const vh = sourceVideo.videoHeight;
        if (!vw || !vh || sourceVideo.readyState < 2) return;

        if (canvas.width !== vw || canvas.height !== vh) {
            canvas.width = vw;
            canvas.height = vh;
        }

        try {
            ctx.drawImage(sourceVideo, 0, 0, vw, vh);
            // Bez videoEl → geometria maski liczona jako % klatki (stała, z configu).
            drawStreamPrivacyMask(ctx, canvas, vw, vh, STREAM_PRIVACY_MASK, {});
        } catch {
            /* klatka jeszcze niegotowa / cross-origin — pomiń */
        }
    };

    rafId = requestAnimationFrame(draw);

    return {
        stream,
        stop() {
            running = false;
            cancelAnimationFrame(rafId);
            for (const track of stream.getTracks()) track.stop();
        },
    };
}
